<ng-select
  [virtualScroll]="true"
  [ngClass]="className"
  (change)="changed.emit($event)"
  [placeholder]="placeholder"
  [items]="items"
  class="custom"
  [bindLabel]="bindLabel"
  [bindValue]="bindValue"
  [(ngModel)]="model">
</ng-select>
